import script from "./AdminOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOverview.vue?vue&type=script&setup=true&lang=js"

import "./AdminOverview.vue?vue&type=style&index=0&id=12bdb1ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12bdb1ac"]])

export default __exports__